//# sourceMappingURL=organization.mjs.map
/// <reference types="./organization.d.mts" />
import * as $redraw from "../../redraw/redraw.mjs";
import * as $route from "../data/route.mjs";
import * as $ai_search from "../view/organization/ai_search.mjs";
import * as $authentication from "../view/organization/authentication.mjs";
import * as $automations from "../view/organization/automations.mjs";
import * as $feature_flags from "../view/organization/feature_flags.mjs";
import * as $setup from "../view/organization/setup.mjs";
import * as $status from "../view/organization/status.mjs";
import * as $weaviate from "../view/organization/weaviate.mjs";

export function view() {
  return $redraw.compose(
    $authentication.view(),
    (authentication) => {
      return $redraw.compose(
        $setup.view(),
        (setup) => {
          return $redraw.compose(
            $ai_search.view(),
            (ai_search) => {
              return $redraw.compose(
                $automations.view(),
                (automations) => {
                  return $redraw.compose(
                    $feature_flags.view(),
                    (feature_flags) => {
                      return $redraw.compose(
                        $weaviate.view(),
                        (weaviate) => {
                          return $redraw.compose(
                            $status.view(),
                            (status) => {
                              return $redraw.component_(
                                "Organization",
                                (_use0) => {
                                  let route = _use0[0];
                                  if (route instanceof $route.Authentication) {
                                    let route$1 = route[0];
                                    return authentication([route$1]);
                                  } else if (route instanceof $route.Setup) {
                                    let route$1 = route[0];
                                    return setup([route$1]);
                                  } else if (route instanceof $route.AiSearch) {
                                    return ai_search(undefined);
                                  } else if (route instanceof $route.Automations) {
                                    return automations(undefined);
                                  } else if (
                                    route instanceof $route.FeatureFlags
                                  ) {
                                    return feature_flags(undefined);
                                  } else if (route instanceof $route.Status) {
                                    return status(undefined);
                                  } else {
                                    return weaviate(route);
                                  }
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
